import { createCtx } from '@reatom/framework'
import { createTestCtx } from '@reatom/testing'

import { DEMO_MODE } from '@root/shared/environment'

export const rootCtx = DEMO_MODE ? createTestCtx() : createCtx()
